var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-preview"},[_c('div',{staticClass:"c-progress"},[_c('div',{staticClass:"c-currency",style:({
            color: _vm.textColor,
        })},[_c('span',{staticClass:"c-currency__total"},[_vm._v(_vm._s(_vm.toCurrency(_vm.amountProgress)))]),_vm._v(" of "),_c('span',{staticClass:"c-currency__goal"},[_vm._v(_vm._s(_vm.toCurrency(_vm.goal))+" goal")])]),_c('div',{style:({
                backgroundColor: _vm.progressColor,
                borderRadius: _vm.borderRadius + 'px',
                borderWidth: _vm.borderSize + 'px',
                borderColor: _vm.progressColor,
                borderStyle: 'solid',
        })},[_c('b-progress',{class:{'position-relative': _vm.progress < 50},style:({
                    backgroundColor: _vm.backgroundColor,
                    borderRadius: _vm.borderRadius + 'px',

                }),attrs:{"show-progress":"","animated":"","max":100}},[(_vm.progress >= 50)?_c('b-progress-bar',{style:({
                        backgroundColor: _vm.progressColor,
                        color: _vm.percentageColor,

                    }),attrs:{"value":_vm.progress,"label":`${(
                        (_vm.progress / 100) *
                        100
                    ).toFixed(0)}%`,"variant":_vm.progressColor}}):_c('b-progress-bar',{style:({
                        backgroundColor: _vm.progressColor,
                        color: _vm.textColor,
                    }),attrs:{"value":_vm.progress,"label-html":`<span class='progress-bar-label-right'>${(
                        (_vm.progress / 100) *
                        100
                    ).toFixed(0)}%</span>`,"variant":_vm.progressColor}})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }